import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "p-3 position-relative" }
const _hoisted_4 = { class: "row m-0" }
const _hoisted_5 = {
  key: 0,
  class: "col border border-5 border-white-and-rounded bg-light-warning d-flex align-items-center p-4 rounded-2"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-building fs-3x text-warning" })
], -1)
const _hoisted_8 = { class: "col mt-5" }
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 1,
  class: "col border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center p-4 rounded-2"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hotel fs-3x text-primary" })
], -1)
const _hoisted_13 = { class: "col mt-5" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "col border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-book fs-3x text-success" })
], -1)
const _hoisted_18 = { class: "col mt-5" }
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 2,
  class: "col border border-5 border-white-and-rounded bg-light-danger d-flex align-items-center p-4 rounded-2"
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chalkboard-teacher fs-3x text-danger" })
], -1)
const _hoisted_23 = { class: "col mt-5 ml-1" }
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "col border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_28 = { class: "col mt-5" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "card mt-6" }
const _hoisted_31 = { class: "card-body p-0" }
const _hoisted_32 = { class: "p-3 position-relative" }
const _hoisted_33 = { class: "row m-0" }
const _hoisted_34 = { class: "col border border-5 border-white-and-rounded bg-light-warning d-flex align-items-center p-4 rounded-2" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-warning d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-running fs-3x text-warning" })
], -1)
const _hoisted_37 = { class: "col mt-5" }
const _hoisted_38 = ["href"]
const _hoisted_39 = { class: "col border border-5 border-white-and-rounded bg-light-primary d-flex align-items-center p-4 rounded-2" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-primary d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-id-card fs-3x text-primary" })
], -1)
const _hoisted_42 = { class: "col mt-5" }
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "col border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-house-user fs-3x text-success" })
], -1)
const _hoisted_47 = { class: "col mt-5" }
const _hoisted_48 = ["href"]
const _hoisted_49 = { class: "col border border-5 border-white-and-rounded bg-light-danger d-flex align-items-center p-4 rounded-2" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "d-block my-2 col-md-3 mr-4"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-graduate fs-3x text-danger" })
], -1)
const _hoisted_52 = { class: "col mt-5 ml-1" }
const _hoisted_53 = ["href"]
const _hoisted_54 = { class: "col border border-5 border-white-and-rounded bg-light-success d-flex align-items-center p-4 rounded-2" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", {
  style: {"width":"35%"},
  class: "svg-icon svg-icon-3x svg-icon-success d-block my-2 col-md-3 mr-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tie fs-3x text-success" })
], -1)
const _hoisted_57 = { class: "col mt-5" }
const _hoisted_58 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.entity_type_id === '1004')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.association_count), 1),
                    _createElementVNode("a", {
                      href: `${this.VUE_APP_DOPTOR}/association/entity-list`,
                      target: "_blank",
                      class: "text-dark fw-bold fs-6 mt-2"
                    }, "Training Partners", 8, _hoisted_9)
                  ])
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.entity_type_id != '1011'
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.training_institute_count), 1),
                    _createElementVNode("a", {
                      href: `${this.VUE_APP_TMS}/report/status-monitoring-report`,
                      target: "_blank",
                      class: "text-dark fw-bold fs-6 mt-2"
                    }, "Institutes", 8, _hoisted_14)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.course_count), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_DOPTOR}/course/course-list`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Courses", 8, _hoisted_19)
              ])
            ]),
            (_ctx.trainer_count !='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.trainer_count), 1),
                    _createElementVNode("a", {
                      href: `${this.VUE_APP_TMS}/report/status-monitoring-report`,
                      target: "_blank",
                      class: "text-dark fw-bold fs-6 mt-2"
                    }, "Trainers", 8, _hoisted_24)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("h4", _hoisted_28, _toDisplayString(_ctx.assessor_count), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_TMS}/report/status-monitoring-report`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Assessors", 8, _hoisted_29)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("h4", _hoisted_37, _toDisplayString(_ctx.running_batch), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_DOPTOR}/running-batch-list`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Running Batchs", 8, _hoisted_38)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("h4", _hoisted_42, _toDisplayString(_ctx.pending_enrollment), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_DOPTOR}/pending-enrollment-list`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Pending Enrollments", 8, _hoisted_43)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("h4", _hoisted_47, _toDisplayString(_ctx.pending_attendance), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_DOPTOR}/pending-attendance-list`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Pending Attendances", 8, _hoisted_48)
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("h4", _hoisted_52, _toDisplayString(_ctx.pending_assessment), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_DOPTOR}/pending-assessment-list`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Pending Asssessments", 8, _hoisted_53)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("h4", _hoisted_57, _toDisplayString(_ctx.pending_employment), 1),
                _createElementVNode("a", {
                  href: `${this.VUE_APP_DOPTOR}/pending-employment-list`,
                  target: "_blank",
                  class: "text-dark fw-bold fs-6 mt-2"
                }, "Pending Employments", 8, _hoisted_58)
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}